<template>
    <v-sheet :color="color" v-bind:style="style" elevation="4" rounded>
        <table>
            <tr>
                <td style="text-align:center">
                    <v-btn 
                        height="34" 
                        icon 
                        @click="$emit('click')">
                        <v-icon>{{icon}}</v-icon>
                    </v-btn>
                </td>
            </tr>
            <tr v-if="name != ''">
                <td style="white-space:nowrap">
                    <div 
                        class="caption" 
                        style="width:100%; text-align:center; margin-top:-8px;">
                        {{name}}
                    </div>
                </td>
            </tr>
        </table>
    </v-sheet>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: "primary"
            },
            icon: String,
            name: {
                type: String,
                default: ""
            },
            popout: {
                type: String,
                default: "top"
            }
        },
        computed: {
            style: function () {
                switch (this.popout) {
                    case "top":
                        return "margin-top:-16px; margin-left:10px"
                    case "bottom":
                        return "margin-top:16px; margin-left:10px"
                    case "none":
                        return "margin-top:0px; margin-left:10px"
                }
            }
        },
        methods: {
        }
    }
</script>
